import React, {useEffect} from "react";
import {Box, Alert,} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentTab } from "state/tabSlice";
import Receipts from "../tables/receiptTable";
import Invoices from "../tables/invoiceTable";
import RefundsTable from "../tables/refundsTable";
import CustomTab from "components/Tabs/Tab";
import CustomerInvoices from "../tables/customerInvoiceTable";


const BillingTab = () => {
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(useSelector((state)=> state.tabReducer.currentTab['humanResourceTab']) );
  // const permissions = useSelector((state) => state.authReducer.permissions);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    dispatch(setCurrentTab({ name: "humanResourceTab", tab: newValue })); 
  };

  const [isSuccess, setIsSuccess] = React.useState(false);
  const [isFailed, setIsFailed] = React.useState(false);

  const tabComponents = [
    {Component: <Invoices setIsSuccess={setIsSuccess}/>, label: "BILLS", "index": 0},
    {Component: <CustomerInvoices />, label: "INVOICES", "index": 1},
    {Component: <Receipts />, label: "RECEIPTS", "index": 2},
    {Component: <RefundsTable />, label: "REFUNDS", "index": 3},
  ] 

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsSuccess(false);
      setIsFailed(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [isSuccess, isFailed]);

  return (
    <Box p={1}>
      {isSuccess ? (
        <Alert sx={{ m: "15px" }} variant="filled" severity="success">
          Operation was successful!
        </Alert>
      ) : isFailed ? (
        <Alert sx={{ m: "15px" }} severity="error">
          Operation was not successful!
        </Alert>
      ) : null}
        
      <CustomTab tabComponents={tabComponents} value={value} handleChange={handleChange}/>
    </Box>
  );
};

export default BillingTab;